import { createProductTrialPageLink } from "./createProductPageLinks"
import { localizeUrl } from "@/lib/url/localizeUrl"

export const formatLink = (
  link: string,
  currentLocale = "en",
  type: string | null | undefined = null,
  homepageSlug?: string | undefined | null,
  products?: any | undefined | null,
  locale?: string | undefined | null,
  productLink?: string | undefined | null,
) => {
  if (productLink && typeof productLink === "string") {
    return createProductTrialPageLink(locale, productLink)?.url
  }

  let formattedLink: string | undefined

  if (link && typeof link === "string" && link?.endsWith("-page-base")) {
    formattedLink = link.replace("-page-base", "")
  }

  if (type && type === "ContentfulProductPage" && link) {
    return localizeUrl(`/products${link.toLowerCase()}`, currentLocale)
  }

  if (formattedLink) {
    return localizeUrl(
      formattedLink.startsWith("/") ? formattedLink : `/${formattedLink}`,
      currentLocale,
    )
  }

  if (link?.startsWith("http") || /^(mailto|tel|sms):/i.test(link || "")) {
    return link
  }

  if (link && typeof link === "string") {
    if (link === homepageSlug) {
      return `/${currentLocale}/`
    }
    const path = link.startsWith("/") ? link : `/${link}`
    return localizeUrl(path, currentLocale)
  }

  return link
}
